// The looping Symphony logo mark shown beside the thinking line — the eight logo
// dots pulsing in sequence around the ring. Implemented as inline SVG + a CSS
// keyframe (`.orion-task-loader`, globals.css) rather than Lottie: the design's
// exported Lottie uses `rc` rectangle shapes that lottie-web renders as empty
// paths, so the animation is reproduced directly here. Fills follow the theme
// (recoloured via .orion-task-loader in globals.css).

// Dot layout copied from the logo animation (30×31 canvas): centre, square size
// and corner radius per dot, in the sequence they animate.
const DOTS = [
  { cx: 15.486, cy: 3.072, s: 6.14467, r: 0.409645 },
  { cx: 6.673, cy: 6.714, s: 6.14467, r: 0.921701 },
  { cx: 3.072, cy: 15.044, s: 6.14467, r: 1.33135 },
  { cx: 6.673, cy: 23.474, s: 6.14467, r: 1.74099 },
  { cx: 15.486, cy: 27.029, s: 6.14467, r: 2.15063 },
  { cx: 23.58, cy: 23.474, s: 6.14467, r: 2.66269 },
  { cx: 26.931, cy: 15.044, s: 6.14467, r: 3.07234 },
  { cx: 23.571, cy: 6.688, s: 4.32715, r: 2.16357 },
];

export function TaskLoaderMark({ size = 20 }: { size?: number }) {
  return (
    <span className="orion-task-loader" aria-hidden style={{ display: 'inline-flex', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} viewBox="0 0 30 31" fill="none" aria-hidden>
        {DOTS.map((d, i) => (
          <rect
            key={i}
            x={d.cx - d.s / 2}
            y={d.cy - d.s / 2}
            width={d.s}
            height={d.s}
            rx={d.r}
            style={{ transformBox: 'fill-box', transformOrigin: 'center', animationDelay: `${i * 0.11}s` }}
          />
        ))}
      </svg>
    </span>
  );
}
